const hasPrice = (value) => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0;
};

/** Used when a property has not filled meal-package rates */
export const DEFAULT_MEAL_PRICES = {
  vegAdult: 1200,
  vegChild: 600,
  nonVegAdult: 1400,
  nonVegChild: 700,
};

export const resolveMealPrice = (value, fallback) =>
  hasPrice(value) ? Number(value) : fallback;

export const formatInr = (value) =>
  `₹${Number(value).toLocaleString("en-IN")}`;

export const getResolvedMealPrices = (villaData) => ({
  vegAdult: resolveMealPrice(
    villaData?.meal_package_veg_adult_price,
    DEFAULT_MEAL_PRICES.vegAdult
  ),
  vegChild: resolveMealPrice(
    villaData?.meal_package_veg_child_price,
    DEFAULT_MEAL_PRICES.vegChild
  ),
  nonVegAdult: resolveMealPrice(
    villaData?.meal_package_non_veg_adult_price,
    DEFAULT_MEAL_PRICES.nonVegAdult
  ),
  nonVegChild: resolveMealPrice(
    villaData?.meal_package_non_veg_child_price,
    DEFAULT_MEAL_PRICES.nonVegChild
  ),
});

export { hasPrice };
